import concat from 'xstream/extra/concat'
import actions from './actions'
import intent from './intent'
import model from './model'
import xs from 'xstream'

export function RowSlider({ DOM, Time }) {
  const element$ = DOM.element()
  const row$ = DOM.select('[data-rowslider-row]').element()
  const rows$ = DOM.select('[data-rowslider-row]').elements()
  const scroller$ = DOM.select('[data-rowslider-scroller]').element()
  const receptacle$ = DOM.select('[data-rowslider-receptacle]').element()

  const intents = intent({ DOM, Time })
  const position$ = model(intents)

  const rowWidth$ = intents.resize$
    .startWith({})
    .mapTo(row$)
    .flatten()
    .map(({ clientWidth }) => clientWidth)

  const init$ = xs.combine(row$, scroller$).take(1).map(actions.init)

  const autoScroll$ = xs
    .combine(intents.isScrollable$, position$, rows$, rowWidth$)
    .filter(([isScrollable]) => isScrollable)
    .map(([, ...rest]) => rest)
    .map(actions.autoScroll)

  const scrollLoop$ = xs
    .combine(intents.isScrollable$, rowWidth$, intents.scrollLeft$, scroller$)
    .filter(
      ([isScrollable, rowWidth, scrollLeft]) =>
        (isScrollable && scrollLeft > rowWidth) || scrollLeft < rowWidth,
    )
    .map(([, ...rest]) => rest)
    .map(actions.scrollLoop)

  const makeScrollable$ = xs
    .combine(element$, intents.isScrollable$)
    .map(actions.toggleScrollable)

  const resetScroll$ = intents.isScrollable$
    .filter(x => !x)
    .map(() => xs.combine(rows$, scroller$))
    .flatten()
    .map(actions.resetScroll)

  return {
    DOM: concat(
      init$,
      xs.merge(makeScrollable$, resetScroll$, autoScroll$, scrollLoop$),
    ),
  }
}

export default RowSlider



// WEBPACK FOOTER //
// ./rowSlider/index.js